import {
  LevelPlay as AdPlugin,
  RewardAdOptions,
  AdLoadInfo,
  RewardAdPluginEvents,
  RewardItem,
  LevelPlayError as AdError,
} from "@ironfly/capacitor-levelplay";

export async function initialize(): Promise<void> {
  await AdPlugin.initialize();
}

export function prepareAd(userId?: string): Promise<AdLoadInfo> {
  // since levelplay have two different id for the platform,
  // remove CREDIT_CONFIG.rewardedAdUnitId and use the embedded one in the plugin
  const options: RewardAdOptions = {};

  if (userId) {
    options.ssv = { userId };
  }

  return AdPlugin.prepareRewardVideoAd(options);
}

export function showPreparedAd(): Promise<void> {
  return AdPlugin.showRewardVideoAd();
}

export function subscribeToLoaded(listener: (info: AdLoadInfo) => void) {
  return AdPlugin.addListener(RewardAdPluginEvents.Loaded, listener);
}

export function subscribeToRewarded(listener: (reward: RewardItem) => void) {
  return AdPlugin.addListener(RewardAdPluginEvents.Rewarded, listener);
}

export function subscribeToFailedToLoad(listener: (error: AdError) => void) {
  return AdPlugin.addListener(RewardAdPluginEvents.FailedToLoad, listener);
}

export function subscribeToDismissed(listener: () => void) {
  return AdPlugin.addListener(RewardAdPluginEvents.Dismissed, listener);
}

export function subscribeToFailedToShow(listener: (error: AdError) => void) {
  return AdPlugin.addListener(RewardAdPluginEvents.FailedToShow, listener);
}

export function getErrorMessage(error: AdError): string {
  switch (error.code) {
    case 0:
      return "This indicates that something happened internally; for instance, an invalid response was received from the ad server.";
    case 1:
      return "The ad request was invalid; for instance, the ad unit ID was incorrect.";
    case 2:
      return "The ad request was unsuccessful due to network connectivity.";
    case 3:
      return "The ad request was successful, but no ad was returned due to lack of ad inventory.";
    default:
      return "An unexpected error occurred. Please try again later.";
  }
}
